import React, { useEffect } from "react";
import { Box, Grid, Skeleton, Typography } from "@mui/material";
import { Form, FormField } from "../../Form/Form";
import { DealInformationSectionProps } from "../DealInformationConfig";

import { CurrencyFormatter } from "../../MuiCustomNumberFormat";
import {
  transformBudget,
  useGetDealInfoBudget,
} from "../../../adapters/DealInformation/Budget/Budget";
import { Alert } from "../../Alert";

export const BudgetInfo = (props: DealInformationSectionProps) => {
  const data = useGetDealInfoBudget(props.dealId);

  const { form, setDataState } = props;

  useEffect(() => {
    if (data.data) {
      form.setValue("budget", transformBudget(data.data));
      setDataState((prev) => ({ ...prev, budgetLoaded: true }));
    } else {
      setDataState((prev) => ({ ...prev, budgetLoaded: false }));
    }
  }, [data, form, setDataState]);

  if (data.error) {
    return (
      <Alert
        variant="filled"
        type="error"
        title="Oops, something went wrong..."
        text="Please refresh your browser and try again"
      />
    );
  }

  if (!data.data) {
    return <Skeleton />;
  }

  const leaseFields: FormField[] = [
    {
      type: "text",
      fieldName: "budget.budgetRent",
      label: "Budget Rent",
      helperText: "",
      columns: 6,
      customComp: CurrencyFormatter,
      adornment: {
        position: "start",
        value: "$",
      },
    },
    {
      type: "text",
      fieldName: "budget.budgetOutgoings",
      label: "Budget Outgoings",
      helperText: "",
      columns: 6,
      customComp: CurrencyFormatter,
      adornment: {
        position: "start",
        value: "$",
      },
    },

    {
      type: "text",
      fieldName: "budget.budgetPromotionLevy",
      label: "Budget Promotion Levy",
      helperText: "",
      customComp: CurrencyFormatter,
      adornment: {
        position: "start",
        value: "$",
      },
      columns: 6,
    },
  ];

  const incentiveFields: FormField[] = [
    {
      type: "text",
      fieldName: "budget.budgetIncentive",
      label: "Budget Incentive",
      helperText: "",
      columns: 6,
      customComp: CurrencyFormatter,
      adornment: {
        position: "start",
        value: "$",
      },
    },
    {
      type: "text",
      fieldName: "budget.budgetLessorworks",
      label: "Budget Lessorworks",
      helperText: "",
      columns: 6,
      customComp: CurrencyFormatter,
      adornment: {
        position: "start",
        value: "$",
      },
    },
    {
      type: "text",
      fieldName: "budget.budgetMakegood",
      label: "Budget Makegood",
      helperText: "",
      customComp: CurrencyFormatter,
      adornment: {
        position: "start",
        value: "$",
      },
      columns: 6,
    },
  ];

  const valuationFields: FormField[] = [
    {
      type: "text",
      fieldName: "budget.budgetRentValuation",
      label: "Budget Rent Valuation",
      helperText: "",
      columns: 12,
      customComp: CurrencyFormatter,
      adornment: {
        position: "start",
        value: "$",
      },
    },
  ];

  return (
    <>
      <Form form={props.form} fields={valuationFields} />

      {/* Lease section */}
      <Box p={1} width="100%" />
      <Grid item sm={4}>
        <Typography variant="subtitle2">Lease details</Typography>
      </Grid>
      <Form form={props.form} fields={leaseFields} />

      {/* Incentive section */}
      <Box p={1} width="100%" />
      <Grid item sm={4}>
        <Typography variant="subtitle2">Incentive details</Typography>
      </Grid>
      <Form form={props.form} fields={incentiveFields} />
    </>
  );
};
